import type { CreateConversationMessagePayload } from "#features/conversations/api/useCreateConversationMessageMutation.ts";
import { AiMutationKeys } from "#lib/AiQueryKeys.ts";
import { useIsMutating } from "@tanstack/react-query";

export const useIsCreateConversationMessageMutating = (conversationId: string) => {
    const isMutating = useIsMutating({
        mutationKey: AiMutationKeys.CreateConversationMessage(),
        predicate: mutation => {
            const payload = mutation.state.variables as CreateConversationMessagePayload | undefined;

            return payload?.conversationId === conversationId;
        }
    });

    return isMutating > 0;
};
